import React, { Fragment } from 'react'
import { Input } from 'loyal-react'
import PropTypes from 'prop-types'
import './Input.css'

const Company = ({
  participant,
  errors,
  disabled,
  updateState
}) => {
  return (
    <Fragment>
      <div className='col-md-6'>
        <Input
          id='companyName'
          label='Razão Social'
          name='companyName'
          value={participant.name}
          minLength='1'
          maxLength='100'
          required
          data-error='Digite uma Razão Social válida'
          valid={errors.name}
          disabled={disabled.name}
          onChange={(e) => updateState('name', e.target.value, true)}
        />
      </div>
      <div className='col-md-6 dynamic-margin'>
        <Input
          id='documentNumber'
          label='CNPJ'
          name='cnpj'
          mask={[/\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '/',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/
          ]}
          required
          value={participant.documentNumber}
          valid={errors.documentNumber}
          error='Digite um CNPJ válido'
          disabled={disabled.documentNumber}
          onChange={(e) => updateState('documentNumber', e.target.value, true)}
        />
      </div>
      <div className='col-sm-6 mt-2'>
        <Input
          id='ie'
          name='ie'
          label='Inscrição Estadual'
          required
          value={participant.ie}
          valid={errors.ie}
          data-error='Digite uma Inscrição Estadual válida'
          disabled={disabled.ie}
          onChange={(e) => updateState('ie', e.target.value, true)}
        />
      </div>
      <div className='col-sm-6 mt-2'>
        <Input
          id='partnerCpf'
          label='CPF do Sócio'
          mask={[
            /\d/,
            /\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/
          ]}
          required
          value={participant.partnerCpf}
          valid={errors.partnerCpf}
          data-error='Digite um CPF válido'
          disabled={disabled.partnerCpf}
          onChange={(e) => updateState('partnerCpf', e.target.value, true)}
        />
      </div>
    </Fragment>
  )
}

Company.propTypes = {
  participant: PropTypes.object,
  errors: PropTypes.object,
  disabled: PropTypes.object,
  updateState: PropTypes.func
}

export default Company



// WEBPACK FOOTER //
// ./src/features/UserInfosValidation/Company.js